'use client'
import React, { useEffect, useRef, useState } from 'react'

declare global {
    interface Window {
        sparkStream: any
    }
}

interface Props {
    adUnitCode: string
    videoUrls?: Array<string>
    playerMode?: string
    posterUrls?: Array<string>
}

export const SparkStream: React.FC<Props> = (props) => {
    const sparkStreamContainerRef = useRef<HTMLDivElement | null>(null)
    const [isScriptLoaded, setIsScriptLoaded] = useState(false)
    const [isContainerReady, setIsContainerReady] = useState(false)

    // Check when container is mounted
    useEffect(() => {
        if (sparkStreamContainerRef.current) {
            setIsContainerReady(true)
        }
    }, [])

    // Load the script once
    useEffect(() => {
        const script = document.createElement('script')
        script.type = 'text/javascript'
        script.async = true
        script.src = 'https://adforge.io/spark-stream?domain=theinventory.com'

        script.onload = () => {
            setIsScriptLoaded(true)
        }

        document.head.appendChild(script)
    }, [])

    // Only initialize when both script and container are ready
    useEffect(() => {
        if (isScriptLoaded && isContainerReady) {
            initializeStream()
        }
    }, [isScriptLoaded, isContainerReady, props])

    const initializeStream = () => {
        const container = sparkStreamContainerRef.current
        if (!window.sparkStream || !container) return
        container.innerHTML = ''

        const targetContainerId = container.id || 'sparkStreamContainer'
        window.sparkStream.queue = window.sparkStream.queue || []

        window.sparkStream.queue.push(() => {
            window.sparkStream.init({
                targetContainerId,
                ...props,
            })
        })
    }

    return <div ref={sparkStreamContainerRef} id='sparkStreamContainer' />
}
